import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['container', 'content'];

  connect() {
    document.addEventListener('promote:open-import-editor', this._openEditor.bind(this));
    document.addEventListener('promote:close-import-editor', this.closeEditor.bind(this));
  }

  disconnect() {
    document.removeEventListener('promote:open-import-editor', this._openEditor.bind(this));
    document.removeEventListener('promote:close-import-editor', this.closeEditor.bind(this));
  }

  closeEditor() {
    this.containerTarget.classList.add('closed', 'initial-state');
    this.contentTarget.innerHTML = '';

    document.dispatchEvent(new CustomEvent('promote:editor-closed'));

    document.dispatchEvent(new CustomEvent('promote:shortcuts--unregister', {
      detail: { group: 'editor' }
    }));
  }

  highlightBackground() {
    const moduleId = event.currentTarget.dataset.id
    const card = document.getElementById(`import-card-${moduleId}`);

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        document.dispatchEvent(new CustomEvent('promote:highlight', {
          detail: { element: card }
        }));
      }
    });
  }

  toggleCheckbox(event) {
    const ignoreTags = ['INPUT', 'A'];
    if (ignoreTags.includes(event.target.tagName)) return

    const checkbox = event.currentTarget.querySelector("input[type='checkbox']");

    if (!checkbox) return;

    checkbox.click();
  }

  _openEditor() {
    this.containerTarget.classList.remove('initial-state');
    this.containerTarget.classList.remove('closed');

    document.dispatchEvent(new CustomEvent('promote:editor-opened'));

    document.dispatchEvent(new CustomEvent('promote:shortcuts--register', {
      detail: {
        key: 'Escape',
        group: 'editor',
        handler: this.closeEditor.bind(this)
      }
    }));
  }
}
